import { Controller } from '@hotwired/stimulus'

// When each URL last refreshed itself. A morphing refresh reconnects this
// controller, so without this the page would schedule its own next refresh
// forever.
const refreshedAt = new Map()
const GUARD_MS = 10000

// Refreshes the page once, shortly after it connects.
//
// A broadcast that fires while the browser is still following a redirect is
// never delivered: the page being left has dropped its subscription and the
// page arriving has not made one yet. So somebody sent back from an errand can
// land on a page that is already stale, with nothing further coming to correct
// it. One scheduled refresh closes that window; the live subscription covers
// everything after, which is why this fires once rather than polling.
//
// Coming back later — a second errand, say — is a fresh arrival and refreshes
// again, because the guard has expired by then.
export default class extends Controller {
  static values = { delay: { type: Number, default: 1500 } }

  connect() {
    if (this.refreshedRecently) return

    this.timeout = setTimeout(() => this.refresh(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  refresh() {
    if (document.visibilityState === 'hidden') return

    refreshedAt.set(window.location.href, Date.now())

    // Turbo is already on the window once the pack has booted it; a plain
    // reload is the fallback, and loses only the morph.
    if (window.Turbo) {
      window.Turbo.visit(window.location.href, { action: 'replace' })
    } else {
      window.location.reload()
    }
  }

  get refreshedRecently() {
    const at = refreshedAt.get(window.location.href)

    return at !== undefined && Date.now() - at < GUARD_MS
  }
}
